import "./Products.css";
import list from "../../../../assets/list.png";
import list2 from "../../../../assets/list2.png";

import Card from "./components/Card/Card";
import Pagination from "../Pagination/Pagination";
const Products = ({ setAffiliateModal }) => {
 return (
  <div className="dashboard-products">
   <div className="first-container">
    <p>18903 Results</p>
    <div>
     <img src={list2} alt="list" />
     <img src={list} alt="list" />
    </div>
   </div>
   <div className="second-container">
    <div className="card-container">
     <Card setAffiliateModal={setAffiliateModal} type="Events" />
    </div>
    <div className="card-container">
     <Card type="Course" />
    </div>
    <div className="card-container">
     <Card type="Training" />
    </div>
    <div className="card-container">
     <Card type="Vocational skill" />
    </div>

    <div className="card-container">
     <Card type="Events" />
    </div>
    <div className="card-container">
     <Card type="Events" />
    </div>

    <Pagination />
   </div>
  </div>
 );
};

export default Products;
